import { render, staticRenderFns } from "./dropup.vue?vue&type=template&id=7453aaa4"
import script from "./dropup.vue?vue&type=script&lang=js"
export * from "./dropup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports